<script>
   /*************************************************************/
   /* AppPlots component for training app                       */
   /* -----------------------------------                       */
   /* defines plot components, controls and parameters          */
   /*************************************************************/

   import { getDefaults } from 'svelte-controls-basic';
   import { Container, Button } from 'svelte-controls-basic';

   // global plot router
   import PlotsRouter from '../../../shared/plots/PlotsRouter.svelte';

   // import plot components
   import PlotScores from '../../../shared/plots/PlotScores.svelte';
   import PlotLoadings from '../../../shared/plots/PlotLoadings.svelte';
   import PlotBi from '../../../shared/plots/PlotBi.svelte';
   import PlotVariance from '../../../shared/plots/PlotVariance.svelte';
   import PlotEigenvalues from '../../../shared/plots/PlotEigenvalues.svelte';
   import PlotDistance from '../../../shared/plots/PlotDistance.svelte';

   // import plot controls components
   import { getPlotScoresControls, getPlotLoadingsControls, getPlotBiControls, getPlotVarianceControls,
            getPlotEigenvaluesControls, getPlotDistanceControls } from '../../../shared/plots/Controls.svelte.js';

   let {
      resobj,
      model,
      dataset,
      markOutlier,
      showContributions
   } = $props();

   // because most of the plot components expect JSON with results
   // assuming there is more than one result object we create it
   // same for the data
   let res = {'cal': resobj};
   let data = {'cal': dataset};

   // JSON with plot components (scope is needed for providing correct properties)
   const plots = $derived({
      scores: {label: 'Scores', scope: 'objects', component: PlotScores, buttons: buttons1},
      loadings: {label: 'Loadings', scope: 'stats', component: PlotLoadings},
      biplot: {label: 'Bi-plot', scope: 'stats', component: PlotBi},
      variance: {label: 'Variance', scope: 'stats', component: PlotVariance},
      eigenvals: {label: 'Eigenvalues', scope: 'stats', component: PlotEigenvalues},
      distance: {label: 'Distances', scope: 'objects', component: PlotDistance, buttons: buttons2},
   });

   // JSON with plots controls (as Widget properties)
   const controls = $state({
      scores: getPlotScoresControls(res),
      loadings: getPlotLoadingsControls(model),
      biplot: getPlotBiControls(res),
      variance: getPlotVarianceControls(res),
      eigenvals: getPlotEigenvaluesControls(model),
      distance: getPlotDistanceControls(res)
   })

   // JSON with currently selected plots parameters
   let params = $state({
      scores: getDefaults(controls.scores),
      loadings: getDefaults(controls.loadings),
      biplot: getDefaults(controls.biplot),
      variance: getDefaults(controls.variance),
      eigenvals: getDefaults(controls.eigenvals),
      distance: getDefaults(controls.distance),
   });

   // reactive effects for scores plot controls
   $effect(() => {
      if (params.scores.plotType !== 'p') {
         controls.scores.comp1.hidden = true;
         controls.scores.showEllipse.hidden = true;
         params.scores.showEllipse = false;
      } else {
         controls.scores.comp1.hidden = false;
         controls.scores.showEllipse.hidden = false;
      }

      if (params.scores.plotType === 'l' || params.scores.plotType === 'b') {
         controls.scores.colorBy.hidden = true;
         params.scores.colorBy = 'none';
      } else {
         controls.scores.colorBy.hidden = false;
      }

      if (params.scores.colorBy === 'variable') {
         controls.scores.colorByVar.hidden = false;
      } else {
         controls.scores.colorByVar.hidden = true;
      }

      if (params.scores.colorBy === 'groups' && params.scores.plotType === 'p') {
         controls.scores.confEllipse.hidden = false;
      } else {
         controls.scores.confEllipse.hidden = true;
         params.scores.confEllipse = 'none';
      }

   })

   // reactive effects for loadings plot controls
   $effect(() => {
      if (params.loadings.plotType !== 'p') {
         controls.loadings.comp1.hidden = true;
      } else {
         controls.loadings.comp1.hidden = false;
      }
   })

   // combine main elements to be shared with all plots together
   const props = $derived({res, model, data});

   // combine all callbacks together
   const callbacks = {markOutlier, showContributions};
</script>

{#snippet buttons1(sel)}
   <Container label="Selected">
      <Button onclick={() => markOutlier(sel)} text="remove" />
   </Container>
{/snippet}

{#snippet buttons2(sel)}
   <Container label="Selected">
      <Button onclick={() => showContributions(sel, params.distance.ncomp)} text="plot" />
      <Button onclick={() => markOutlier(sel)} text="remove" />
   </Container>
{/snippet}


<PlotsRouter {plots} {controls} {props} {callbacks} bind:params={params} />